export const map = {
  width: 1506,
  height: 703
};



/** WEBPACK FOOTER **
 ** ./src/styles.js
 **/